var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useRef } from "react";
import classNames from "classnames";
import { Icon } from "../Icon";
import { LazyImage } from "../LazyImage";
import { useScaleFactor } from "../../utils/hooks/useScaleFactor";
// styles
import "./avatar.scss";
// use the optional prop interface to define the default props
const defaultProps = {
    size: "medium",
    "data-testid": "tecma-avatar",
    alt: "tecma-avatar-alternative",
};
/**
 * A graphical representation of a user: usually a photo, illustration, or initial.
 */
const Avatar = (_a) => {
    var { size, className, src, text, alt, icon } = _a, rest = __rest(_a, ["size", "className", "src", "text", "alt", "icon"]);
    const classList = classNames("tecma-avatar", { [`${size}`]: size }, className);
    let childrenToRender;
    const avatarNodeRef = useRef(null);
    const avatarChildrenRef = useRef(null);
    const childrenScale = useScaleFactor(avatarNodeRef, avatarChildrenRef, 4, [text]);
    const imgExist = !!src;
    const iconNameExist = !!icon;
    const textExist = !!text;
    const transformString = childrenScale ? `scale(${childrenScale})` : "";
    if (imgExist) {
        childrenToRender = _jsx(LazyImage.Image, { src: src, alt: alt });
    }
    else if (iconNameExist) {
        childrenToRender = _jsx(Icon, { className: "avatar-icon", iconName: icon, size: size });
    }
    else if (textExist) {
        childrenToRender = _jsx("span", { ref: avatarChildrenRef, children: text });
    }
    else {
        childrenToRender = _jsx("span", {});
    }
    return (_jsx("div", Object.assign({ ref: avatarNodeRef, className: classList }, rest, { children: childrenToRender })));
};
Avatar.defaultProps = defaultProps;
export default React.memo(Avatar);
